import React, { useEffect } from 'react';
import { useRouteError } from 'react-router-dom';

import { webappClient } from '@lib/bugsnag';
import { ErrorPage } from '@components/common/errorPage';

/**
 * Error boundary for the data router. react-router v7 catches route render errors at the route
 * level (via `errorElement`) — they never propagate to the Bugsnag `<ErrorBoundary>` that wraps
 * `<RouterProvider>`, so without this the router falls back to its own default error screen.
 *
 * This restores the pre-data-router behaviour: report the error to Bugsnag (respecting the
 * ignore-list / `onError` filter in @lib/bugsnag) and render the app's `ErrorPage`.
 */
export const RouteErrorBoundary = () => {
  const error = useRouteError();

  useEffect(() => {
    if (error instanceof Error) {
      webappClient.notify(error);
    }
  }, [error]);

  return <ErrorPage />;
};
